import type {SerializedError} from '@reduxjs/toolkit';
import type {FetchBaseQueryError} from '@reduxjs/toolkit/query/react';
import isNumber from 'lodash/isNumber';
import {HttpError} from 'api/http/types';

export const mapRtkErrorToHttpError = (
  error: FetchBaseQueryError | SerializedError,
): HttpError => {
  if ('status' in error) {
    // FetchBaseQueryError
    return new HttpError(
      isNumber(error.status) ? error.status : 500,
      '',
      error.data
        ? `FetchBaseQueryError: ${error.status} data: ${error.data}`
        : `FetchBaseQueryError ${error.toString()}`,
      error.status.toString(),
      error?.data
        ? {
            ...error.data,
          }
        : undefined,
    );
  } else {
    // SerializedError
    return new HttpError(
      500,
      '',
      `SerializedError: ${error.name ?? '<unknown name>'} ${error.message ?? '<unknown message>'}`,
      '',
      error
        ? {
            ...error,
          }
        : undefined,
    );
  }
};
